import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NgbCalendar,
  NgbDate,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { forkJoin } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { TimezoneService } from "src/app/services/timezone";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { ChartType } from "../net-sale/apex.model";
import { ChartOptions, ChartOptions2 } from "../starter.component";
import { ApiService } from "./../../../services/api";
import { ChartDataModel } from "./ChartData.model";
import data from "./ListOfCharts.model.json";
@Component({
  selector: "app-dashboard-report",
  templateUrl: "./dashboard-report-new.component.html",
  styleUrls: ["./dashboard-report.component.scss"],
  providers: [TranslatePipe],
})
export class DashboardReportComponent implements OnInit, OnDestroy {
  @ViewChild("content", { static: true }) private content: ElementRef;
  @ViewChild("graphModalContent") graphModalContent;
  public chartOptions: Partial<ChartOptions>;
  public chartOptions2: Partial<ChartOptions2>;
  Charts = [];
  fromDate;
  toDate;
  private monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  selected: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    Today: [this.timezoneService.get()(), this.timezoneService.get()()],
    Yesterday: [
      this.timezoneService.get()().subtract(1, "days"),
      this.timezoneService.get()().subtract(1, "days"),
    ],
    "Last 7 Days": [
      this.timezoneService.get()().subtract(6, "days"),
      this.timezoneService.get()(),
    ],
    "Last 30 Days": [
      this.timezoneService.get()().subtract(29, "days"),
      this.timezoneService.get()(),
    ],
    "This Month": [
      this.timezoneService.get()().startOf("month"),
      this.timezoneService.get()().endOf("month"),
    ],
    "Last Month": [
      this.timezoneService.get()().subtract(1, "month").startOf("month"),
      this.timezoneService.get()().subtract(1, "month").endOf("month"),
    ],
  };
  invalidDates: moment.Moment[] = [
    this.timezoneService.get()().add(2, "days"),
    this.timezoneService.get()().add(3, "days"),
    this.timezoneService.get()().add(5, "days"),
  ];
  selectedInterval: string = 'year'; // Initialize with the default selected interval, 'year'
  selectedIntervalday: string = 'day'; // Initialize based on your logic
  selectedIntervalMonth: string = 'month'; // Initialize based on your logic

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };
  dateFormat: any = "Month";
  dashedLineChart: ChartType;
  selectedItems = [];
  dropdownSettings = {};
  dropdownList = [];
  //isActiveReport = [];
  settings = false;
  textCurrent: string = "Current";
  textPrevious: string = "Previous";

  selectedGrossGraph: string = "line";
  constructor(
    calendar: NgbCalendar,
    private store: Store<AppState>,
    private cookieService: CookieService,
    private elRef: ElementRef,
    private http: HttpClient,
    private toastr: AlertService,
    private router: Router,
    private ApiService: ApiService,
    private modalService: NgbModal,
    private timezoneService: TimezoneService,
    private renderer: Renderer2,
    private translatePipe: TranslatePipe,
    private BreadcrumbService: BreadcrumbService,

  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
    this.fromDate = this.formatDate(calendar.getToday());
    this.toDate = this.formatDate(
      calendar.getNext(calendar.getToday(), "d", 30)
    );
    this.chartOptions2 = {
      series: [
        {
          name: this.textCurrent,
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
          color: "#000",
        },
        {
          name: this.textPrevious,
          data: [20, 31, 34, 11, 79, 22, 39, 51, 148],
          color: "#888888",
        },
      ],
      chart: {
        height: 200,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      // title: {
      //   text: "Gross Sales",
      //   align: "left"
      // },
      grid: {
        row: {
          colors: ["#0000", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    };
  }

  openGrossGraph() {
    this.modalService.open(this.graphModalContent, {
      size: "lg",
      centered: true,
    });
    this.renderer.removeClass(document.body, "modal-open");
  }

  setGrossGraph(type: string) {
    this.selectedGrossGraph = type;
  }

  taxAliasValue: string = this.cookieService.get("taxAliasValue");
  taxAliasPopoverTitle: string = `Total ${this.taxAliasValue ? this.taxAliasValue : "Taxes"}`;
  taxAliasPopover: string = `Total value of all ${this.taxAliasValue ? this.taxAliasValue : "Taxes"} from paid orders during daily hours of operation`;
  currency: any = this.cookieService.get("currency");
  storeIdFixed: any = this.cookieService.get("storeId");
  merchantId: any = this.cookieService.get("merchantId");
  GLOBALURL: String;
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };

  //current date
  // startDate: any = this.timezoneService.get()().startOf('month');
  // endDate: any = this.timezoneService.get()().endOf('month');
  startDate: any = this.timezoneService.get()().startOf("quarter");
  endDate: any = this.timezoneService.get()().endOf("quarter");



  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  startDateDisplayFormatted: any = this.timezoneService
    .get()
    .unix(this.startDateDisplay)
    .format("MMM Do YYYY");
  endDateDisplayFormatted: any = this.timezoneService
    .get()
    .unix(this.endDateDisplay)
    .format("MMM Do YYYY");
  //Previuos date
  // prevStartDate: any = this.timezoneService.get()().subtract(1, 'month').startOf('month');
  // prevEndDate: any = this.timezoneService.get()().subtract(1, 'month').endOf('month');
  prevStartDate: any = this.timezoneService
    .get()()
    .subtract(1, "quarter")
    .startOf("quarter");
  prevEndDate: any = this.timezoneService
    .get()()
    .subtract(1, "quarter")
    .endOf("quarter");

  prevStartDateDisplay: any = this.prevStartDate.unix();
  prevEndDateDisplay: any = this.prevEndDate.unix();
  prevStartDateDisplayFormatted: any = this.timezoneService
    .get()
    .unix(this.prevStartDateDisplay)
    .format("MMM Do YYYY");
  prevEndDateDisplayFormatted: any = this.timezoneService
    .get()
    .unix(this.prevEndDateDisplay)
    .format("MMM Do YYYY");
  // interval: any = 'day'
  interval: any = "month";
  options: any = {
    locale: { format: "YYYY-MM-DD" },
    // startDate: this.timezoneService.get()().startOf('day'),
    // endDate: this.timezoneService.get()().endOf('day'),
    startDate: this.timezoneService.get()().startOf("month"),
    endDate: this.timezoneService.get()().endOf("month"),
    alwaysShowCalendars: true,
  };
  option2: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.prevStartDate,
    endDate: this.prevEndDate,
    alwaysShowCalendars: true,
  };
  // selectDateoption: any = "This Month";
  // prevSelectDateoption: any = "Last month";

  allEventsList = []

  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Home",
      active: true,
      url: "home",
    },
  ];
  selectDateoption: any = "This Quarter";
  prevSelectDateoption: any = "Last Quarter";

  carouselOption: OwlOptions= {
    items: 1,
    margin: 0,
    nav: false,
    dots: true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    loop:true,
    responsive: {
      680: {
        items: 1
      },
    }
  }

  dateFilteroptions = [
    "Last 4 Weeks",
    "Today",
    "This Week",
    "This Month",
    "This Quarter",
    "Custom",
    // "Yesterday",
    // "Last 7 days",
    // "Last month",
    // "Last 3 months",
    // "Last 12 months",
    // "Month to date",
    // "Quater to date",
    // "Year to date",
    // "All the time"
  ];
  dateFilteroptionscustom=[
    "Previous Period",
    "Previous Year",
    "Custom" ,
    "No Comparison",
  ]
  httpOptions2;
  taxText = this.taxAliasValue ? `Total ${this.taxAliasValue}` : "Total Taxes";
  breakdownStartDate: any
  breakdownEndDate: any
  breakdownStartDateDisplay: any
  breakdownEndDateDisplay: any
  ngOnInit(): void {
    console.log("ngOnInit-this.currency", this.currency);
    this.getRecommendations();
    // this.allEventsList = [
    //   {
    //     name: "Salem's So Sweet Chocolate and Ice Sculpture Festival",

    //     description:
    //       'A decadent celebration of delectable chocolate, sparkling ice sculptures and Valentines Day shopping.',
    //   },
    //   {
    //     name: "2sadasdasdasdasdasdasd",

    //     description:
    //       'A deca2sadsdasdasdasdasdasdasd',
    //   },
    //   {
    //     name: "3dsadasdasdas3333333",

    //     description:
    //       'A d3333333333333333333.',
    //   },
    // ];
    // this.startSlideInterval();
    this.slideInterval = setInterval(() => {
      // console.log("THIS_IS_SLIDE-SHOW")
      this.nextSlide();
    }, 5000);
    // console.log("")
   this.breakdownStartDate = this.timezoneService.get()().startOf("day");
   this.breakdownEndDate = this.timezoneService.get()().endOf("day");
   this.breakdownStartDateDisplay = this.breakdownStartDate.unix();
    this.breakdownEndDateDisplay = this.breakdownEndDate.unix();
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.BreadcrumbService.setValue(this.breadcrumbItems);
    this.httpOptions2 = { headers: new HttpHeaders(this.headerToken) };
    var a = this.timezoneService.get()(this.endDate);
    var b = this.timezoneService.get()(this.startDate);
    var diff = a.diff(b, "days") + 1;
    this.daysDiffrence = diff;
    this.createCharts();
    // this.store.select(getSelectedStoreLocation).subscribe((result) => {
    //   this.currency = result.currency;
    // });

    // forkJoin([
    //   this.translatePipe.transform("Current"),
    //   this.translatePipe.transform("Previous"),
    // ]).subscribe(([textCurrent, textPrevious]) => {
    //   this.textCurrent = textCurrent;
    //   this.textPrevious = textPrevious
    // },
    // (error) => {
    //   console.error("Error in translating", error);
    // })
    this.getAllReports();
    this.getBreakdownReport();

    // let $monthNames = this.monthNames.map(month => this.translatePipe.transform(month));
    // forkJoin($monthNames)
    //   .subscribe((months) => {
    //     for (let index = 0; index < this.monthNames.length; index++) {
    //       this.monthNames[index] = months[index];
    //     }
    //   },
    //   (error) => {
    //     console.error("Error in translating", error);
    //   })

    this.dropdownList = [
      { item_id: 1, item_text: "Gross Sales", active: true, position: 1 },
      { item_id: 2, item_text: "Net Sales", active: true, position: 2 },
      { item_id: 3, item_text: "Total Orders", active: true, position: 3 },
      {
        item_id: 4,
        item_text: "Total Transactions",
        active: true,
        position: 4,
      },
      { item_id: 5, item_text: "Total Refunds", active: true, position: 5 },
      { item_id: 6, item_text: "Total Discounts", active: true, position: 6 },
      { item_id: 7, item_text: this.taxText, active: true, position: 7 },
      { item_id: 8, item_text: "Total Tips", active: true, position: 8 },
      {
        item_id: 9,
        item_text: "Total Delivery Fees",
        active: true,
        position: 9,
      },
    ];

    let $dropdownTranslated = this.dropdownList.map(drop => this.translatePipe.transform(drop.item_text));

    forkJoin($dropdownTranslated)
      .subscribe((dropdowns) => {
        for (let index = 0; index < this.dropdownList.length; index++) {
          this.dropdownList[index].item_text2 = dropdowns[index];
        }
      },
      (error) => {
        console.error("Error translating:", error);
        this.dropdownList.forEach((drop, index) => {
          drop.item_text2 = drop.item_text;
        });
      }
    );
    this.selectedItems = this.dropdownList;
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text2",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: "ShowFilter",
    };

    forkJoin([
      this.translatePipe.transform("Select All"),
      this.translatePipe.transform("UnSelect All"),
      this.translatePipe.transform("Search"),
    ]).subscribe(([selectAllText, unSelectAllText, search]) => {
        this.dropdownSettings["selectAllText"] = selectAllText;
        this.dropdownSettings["unSelectAllText"] = unSelectAllText;
        this.dropdownSettings["searchPlaceholderText"] = search;
      },
      error => {
        console.error("Error translating:", error);
      })

    this.http
      .get(
        this.GLOBALURL + "/user/setting?settingName=HOME_SETTING",
        this.httpOptions2
      )
      .subscribe(
        (resp: any) => {
          if (resp.success != 0) {
            if (resp.success == 1) {
              var userSetting = resp.response.settingValue;
              //this.isActiveReport = userSetting.split(",")
              console.log("userSetting", userSetting);
              if(userSetting != null && userSetting != undefined && userSetting != "") {
                this.selectedItems = userSetting.split(",").map((val) => {
                  if (val == "Total Taxes") {
                    val = this.taxText;
                    console.log("TOTAL TAES", val);
                  }
                  console.log("this.dropdownList_ngOnInit", this.dropdownList);
                  return this.dropdownList.filter(
                    (dropdown) => dropdown["item_text2"] == val
                  )[0];
                }).filter(val => val != undefined);
              } else {
                this.selectedItems = [];
              }
              console.log("Selected_Items_NGONINIT", this.selectedItems);
            }
          }
        },
        (error) => {}
      );
    setTimeout(() => {
      this.store.dispatch(setLoadingSpinner({ status: false }));
    }, 1000);
  }

  changeStore(event: any) {
    this.storeIdFixed = event;
    this.getAllReports();
  }
  createCharts() {
    let temp = data.listOfCharts;
    temp.forEach((chart) => {
      let chartTemp = new ChartDataModel(this.fromDate, this.toDate, chart);
      this.Charts.push(chartTemp);
    });
    console.log("object :>> ", this.createCharts);
  }

  isActive(name: any) {
    return this.selectedItems.find((element) => element?.item_text2 == name)
      ? true
      : false;
  }

  formatDate(date: NgbDate): string {
    let day, month;
    day = date.day;
    month = this.monthNames[date.month - 1];
    return month + "-" + day;
  }

  changeDisplayed(id) {
    let bol = this.Charts[id].display;
    this.Charts[id].display = !bol;
  }

  changeDataByMonth() {
    console.log(this.dateFormat);
  }
  changeDataByWeek() {
    console.log(this.dateFormat);
  }

  changeDataByDay() {
    console.log(this.dateFormat);
  }
  daysDiffrence: any = 0;
  async selectedDateOption(type) {
    this.selectDateoption = type;
    // if (type === "This Month") {
    //   this.daysDiffrence = 30;
    //   this.prevSelectDateoption = "Last Month";
    //   this.prevStartDate = this.timezoneService
    //     .get()()
    //     .subtract(1, "months")
    //     .startOf("month");
    //   this.prevEndDate = this.timezoneService
    //     .get()()
    //     .subtract(1, "months")
    //     .endOf("month");
    //   this.prevStartDateDisplay = this.prevStartDate.unix();
    //   this.prevEndDateDisplay = this.prevEndDate.unix();
    //   this.prevStartDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.prevStartDateDisplay)
    //     .format("MMM Do YYYY");
    //   this.prevEndDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.prevEndDateDisplay)
    //     .format("MMM Do YYYY");
    //   this.startDate = this.timezoneService.get()().startOf("month");
    //   this.endDate = this.timezoneService.get()().endOf("month");
    //   this.startDateDisplay = this.startDate.unix();
    //   this.endDateDisplay = this.endDate.unix();
    //   this.startDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.startDateDisplay)
    //     .format("MMM Do YYYY");
    //   this.endDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.endDateDisplay)
    //     .format("MMM Do YYYY");
    // }
    if (type === "This Month") {
      this.daysDiffrence = 30;
      this.prevSelectDateoption = "Last Month";

      // For last month
      this.prevStartDate = this.timezoneService
        .get()()
        .subtract(1, "months")
        .startOf("month");
      this.prevEndDate = this.timezoneService
        .get()()
        .subtract(1, "months")
        .endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YYYY");
      this.prevEndDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YYYY");

      // For this month
      this.startDate = this.timezoneService.get()().startOf("month");
      this.endDate = this.timezoneService.get()();

      // Ensure the endDate is not beyond today
      if (this.endDate.isAfter(this.timezoneService.get()())) {
        this.endDate = this.timezoneService.get()();
      }

      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.startDateDisplay)
        .format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.endDateDisplay)
        .format("MMM Do YYYY");
    }


//     if (type === "This Month") {
//       const today = this.timezoneService.get()();
//       this.daysDiffrence = 30;
//       this.prevSelectDateoption = "Last Month";
//   this.prevStartDate = today.clone().subtract(1, 'month').startOf('day');
//   this.prevEndDate = this.prevStartDate.clone().endOf('day');
//   this.prevStartDateDisplay = this.prevStartDate.unix();
//   this.prevEndDateDisplay = this.prevEndDate.unix();
//   this.prevStartDateDisplayFormatted = this.timezoneService
//     .get()
//     .unix(this.prevStartDateDisplay)
//     .format('MMM Do YYYY');
//   this.prevEndDateDisplayFormatted = this.timezoneService
//     .get()
//     .unix(this.prevEndDateDisplay)
//     .format('MMM Do YYYY');

//   this.startDate = today.clone().startOf('day');
//   this.endDate = today.clone().endOf('day');
//   this.startDateDisplay = this.startDate.unix();
//   this.endDateDisplay = this.endDate.unix();
//   this.startDateDisplayFormatted = this.timezoneService
//     .get()
//     .unix(this.startDateDisplay)
//     .format('MMM Do YYYY');
//   this.endDateDisplayFormatted = this.timezoneService
//     .get()
//     .unix(this.endDateDisplay)
//     .format('MMM Do YYYY');
// }
     else if (type === "Last Month") {
      this.daysDiffrence = 30;
      this.prevSelectDateoption = "Month before last month";
      this.prevStartDate = this.timezoneService
        .get()()
        .subtract(2, "months")
        .startOf("month");
      this.prevEndDate = this.timezoneService
        .get()()
        .subtract(2, "months")
        .endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YYYY");
      this.prevEndDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YYYY");
      this.startDate = this.timezoneService
        .get()()
        .subtract(1, "months")
        .startOf("month");
      this.endDate = this.timezoneService
        .get()()
        .subtract(1, "months")
        .endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.startDateDisplay)
        .format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.endDateDisplay)
        .format("MMM Do YYYY");
    } else if (type === "Today") {
      this.daysDiffrence = 0;
      this.prevSelectDateoption = "Yesterday";
      this.prevStartDate = this.timezoneService
        .get()()
        .subtract(1, "days")
        .startOf("day");
      this.prevEndDate = this.timezoneService
        .get()()
        .subtract(1, "days")
        .endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YYYY");
      this.prevEndDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YYYY");
      this.startDate = this.timezoneService.get()().startOf("day");
      this.endDate = this.timezoneService.get()().endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.startDateDisplay)
        .format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.endDateDisplay)
        .format("MMM Do YYYY");
    }
    // else if (type === "This Week") {
    //   this.daysDiffrence = 7;
    //   this.prevSelectDateoption = "Last Week";
    //   this.prevStartDate = this.timezoneService
    //     .get()()
    //     .subtract(1, "week")
    //     .startOf("week");
    //   this.prevEndDate = this.timezoneService
    //     .get()()
    //     .subtract(1, "week")
    //     .endOf("week");
    //   this.prevStartDateDisplay = this.prevStartDate.unix();
    //   this.prevEndDateDisplay = this.prevEndDate.unix();
    //   this.prevStartDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.prevStartDateDisplay)
    //     .format("MMM Do YYYY");
    //   this.prevEndDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.prevEndDateDisplay)
    //     .format("MMM Do YYYY");
    //   this.startDate = this.timezoneService.get()().startOf("week");
    //   this.endDate = this.timezoneService.get()().endOf("week");
    //   this.startDateDisplay = this.startDate.unix();
    //   this.endDateDisplay = this.endDate.unix();
    //   this.startDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.startDateDisplay)
    //     .format("MMM Do YYYY");
    //   this.endDateDisplayFormatted = this.timezoneService
    //     .get()
    //     .unix(this.endDateDisplay)
    //     .format("MMM Do YYYY");
    // }
    if (type === "This Week") {
      this.daysDiffrence = 7;
      this.prevSelectDateoption = "Last Week";

      // For last week
      this.prevStartDate = this.timezoneService
        .get()()
        .subtract(1, "week")
        .startOf("week");
      this.prevEndDate = this.timezoneService
        .get()()
        .subtract(1, "week")
        .endOf("week");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YYYY");
      this.prevEndDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YYYY");

      // For this week
      this.startDate = this.timezoneService.get()().startOf("week");
      this.endDate = this.timezoneService.get()();

      // Ensure endDate is not beyond today
      if (this.endDate.isAfter(this.timezoneService.get()())) {
        this.endDate = this.timezoneService.get()();
      }

      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.startDateDisplay)
        .format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.endDateDisplay)
        .format("MMM Do YYYY");
    }

     else if (type === "This Quarter") {
      this.daysDiffrence = 91;
      this.prevSelectDateoption = "Last Quarter";
      this.prevStartDate = this.timezoneService
        .get()()
        .subtract(1, "quarter")
        .startOf("quarter");
      this.prevEndDate = this.timezoneService
        .get()()
        .subtract(1, "quarter")
        .endOf("quarter");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YYYY");
      this.prevEndDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YYYY");
      this.startDate = this.timezoneService
        .get()()
        .quarter(this.timezoneService.get()().quarter())
        .startOf("quarter");
      this.endDate = this.timezoneService
        .get()()
        .quarter(this.timezoneService.get()().quarter())
        .endOf("quarter");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.startDateDisplay)
        .format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService
        .get()
        .unix(this.endDateDisplay)
        .format("MMM Do YYYY");
    }
     else if (type === "Last 4 Weeks") {
      this.daysDiffrence = 28;
      this.prevSelectDateoption = "4 Weeks before last 4 weeks";

      // Calculate the last 4 weeks from the current date back 28 days
      this.startDate = this.timezoneService.get()().subtract(4, "weeks").startOf("day");
      this.endDate = this.timezoneService.get()();

      // Ensure the endDate is not beyond today
      if (this.endDate.isAfter(this.timezoneService.get()())) {
        this.endDate = this.timezoneService.get()();
      }

      // Calculate 4 weeks before the last 4 weeks
      this.prevStartDate = this.startDate.clone().subtract(4, "weeks");
      this.prevEndDate = this.endDate.clone().subtract(4, "weeks");

      // Update displayed dates
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();

      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();

      this.startDateDisplayFormatted = this.timezoneService.get().unix(this.startDateDisplay).format("MMM Do YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get().unix(this.endDateDisplay).format("MMM Do YYYY");

      this.prevStartDateDisplayFormatted = this.timezoneService.get().unix(this.prevStartDateDisplay).format("MMM Do YYYY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get().unix(this.prevEndDateDisplay).format("MMM Do YYYY");
    }
    else if (type === "Last 3 months") {
      this.prevSelectDateoption = "3 months before last 3 months";
    } else if (type === "Last 12 months") {
      this.prevSelectDateoption = "12 months before last 12 months";
    } else if (type === "Month to date") {
    } else if (type === "Quater to date") {
    } else if (type === "Year to date") {
    } else if (type === "All the time") {
      this.prevSelectDateoption = "All the time";
    } else {
      this.prevSelectDateoption = "Custom";
    }
    if (this.daysDiffrence >= 365) {
      this.interval = "year";
    } else if (this.daysDiffrence > 90 && this.daysDiffrence < 365) {
      this.interval = "month";
    } else if (this.daysDiffrence > 60 && this.daysDiffrence < 90) {
      this.interval = "month";
    } else if (this.daysDiffrence > 14 && this.daysDiffrence < 60) {
      this.interval = "day";
    } else if (this.daysDiffrence <= 14 && this.daysDiffrence > 1) {
      this.interval = "day";
    } else if (this.daysDiffrence == 0 || this.daysDiffrence <= 1) {
      this.interval = "hour";
    }
    this.getAllReports();
  }
  selectedDateCustomOption(type) {
    this.prevSelectDateoption = type;
  }
  async selectedDate(value: any) {
    // this.showItemCountPP = 0
    // this.p = 1;

    this.startDate = value.start;
    this.endDate = value.end;

    var a = this.timezoneService.get()(this.endDate);
    var b = this.timezoneService.get()(this.startDate);
    var diff = a.diff(b, "days") + 1;
    this.daysDiffrence = diff;

    this.prevStartDate = this.timezoneService
      .get()(value.start)
      .subtract(diff, "day");
    this.prevEndDate = this.timezoneService
      .get()(value.end)
      .subtract(diff, "day");
    this.prevStartDateDisplay = this.prevStartDate.unix();
    this.prevEndDateDisplay = this.prevEndDate.unix();
    this.prevStartDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.prevStartDateDisplay)
      .format("MMM Do YY");
    this.prevEndDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.prevEndDateDisplay)
      .format("MMM Do YY");
    this.prevSelectDateoption =
      this.prevStartDateDisplayFormatted +
      "-" +
      this.prevEndDateDisplayFormatted;

    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YY");
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YY");
    this.selectDateoption = "Custom";
    this.prevSelectDateoption = "Custom";

    if (this.daysDiffrence >= 365) {
      this.interval = "year";
    } else if (this.daysDiffrence > 90 && this.daysDiffrence < 365) {
      this.interval = "month";
    } else if (this.daysDiffrence > 60 && this.daysDiffrence < 90) {
      this.interval = "month";
    } else if (this.daysDiffrence > 14 && this.daysDiffrence < 60) {
      this.interval = "day";
    } else if (this.daysDiffrence <= 14 && this.daysDiffrence > 1) {
      this.interval = "day";
    } else if (this.daysDiffrence == 0 || this.daysDiffrence <= 1) {
      this.interval = "hour";
    }
    //this.customDate = this.startDateDisplayFormatted + "-" + this.endDateDisplayFormatted
    await this.getAllReports();
  }
  async selectInterval(value: any) {
    this.selectedInterval = value;
    this.selectedIntervalday = value;
    this.selectedIntervalMonth = value; // Initialize based on your logic


    this.interval = value;
    await this.getAllReports();
  }

  async saveReportSetting() {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    var settingValue = [];
    this.selectedItems.map(function (val, index) {
      // printing element
      settingValue.push(val["item_text2"]);
    });
    console.log("User_Settings_Value", settingValue);
    console.log("this.selectedItems", this.selectedItems, this.selectedItems.length);
    let params = {
      settingName: "HOME_SETTING",
      settingValue: "" + settingValue,
    };
    this.settings = !this.settings;
    return this.http
      .post(this.GLOBALURL + "/user/setting", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          this.store.dispatch(setLoadingSpinner({ status: false }));
          if (response) {
            this.toastr.success(response.message);
          } else {
            this.toastr.error(response.message);
          }
        },
        (error) => {
          this.toastr.error(error.message);
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      );
  }
  grossSaleData: ChartType;
  chartTypeArea: ChartType;
  chartTypeBar: ChartType;
  chartTypeColumn: ChartType;

  netSaleData: ChartType;
  totalSaleData: ChartType;
  totalTransactionData: ChartType;
  totalRefundsData: ChartType;
  totalDiscountData: ChartType;
  totalTaxesData: ChartType;
  totalTipsData: ChartType;
  totalDeliveryTipsData: ChartType;

  grossSaleLoader: Boolean = false;
  netSaleLoader: Boolean = false;
  totalSaleLoader: Boolean = false;
  totalTransactionLoader: Boolean = false;
  totalRefundsLoader: Boolean = false;
  totalDiscountLoader: Boolean = false;
  totalTaxesLoader: Boolean = false;
  totalTipsLoader: Boolean = false;
  totalDeliveryTipsLoader: Boolean = false;

  grossSaleBeforeLoader: Boolean = false;
  netSaleBeforeLoader: Boolean = false;
  totalSaleBeforeLoader: Boolean = false;
  totalTransactionBeforeLoader: Boolean = false;
  totalRefundsBeforeLoader: Boolean = false;
  totalDiscountBeforeLoader: Boolean = false;
  totalTaxesBeforeLoader: Boolean = false;
  totalTipsBeforeLoader: Boolean = false;
  totalDeliveryTipsBeforeLoader: Boolean = false;

  grossSaleDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  netSaleDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalSaleDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalTransactionDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalRefundsDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalDiscountDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalTaxesDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalTipsDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  totalDeliveryTipsDataTotal: any = {
    value1: 0.0,
    value2: 0.0,
    percentage: 0.0,
  };
  getAllReports() {
    // let graphCurrency: string = this.currency;
    let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
    const dashedLineChart: ChartType = {
      chart: {
        height: 200,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
      },
      colors: ["#000000", "#cccccc"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [2, 2],
        curve: "straight",
        dashArray: [0, 0, 0],
      },
      series: [
        {
          name: this.textCurrent,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: this.textPrevious,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      title: {
        text: "Page Statistics",
        align: "left",
      },
      markers: {
        size: 0,

        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        categories: [],
      },

      // legend: {
      //   offsetY: 10,
      //   markers: {
      //     width: 7,
      //     height: 7
      //   },
      // },
      yaxis: {
        // title: {
        //     text: 'Points',
        // },
        labels: {
          formatter: function (value) {
            return graphCurrency + ' ' + parseInt(value);
          },
        },
      },
      tooltip: {
        y: [
          {
            title: {
              formatter: (val) => {
                return val;
              },
            },
          },
          {
            title: {
              formatter: (val) => {
                return val;
              },
            },
          },
          {
            title: {
              formatter: (val) => {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        borderColor: "#f1f1f1",
      },
    };
    const totalOrderChart: ChartType = {
      chart: {
        height: 200,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
      },
      colors: ["#000000", "#cccccc"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [2, 2],
        curve: "straight",
        dashArray: [0, 0, 0],
      },
      series: [
        {
          name: this.textCurrent,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: this.textPrevious,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      title: {
        text: "Page Statistics",
        align: "left",
      },
      markers: {
        size: 0,

        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        categories: [],
      },

      // legend: {
      //   offsetY: 10,
      //   markers: {
      //     width: 7,
      //     height: 7
      //   },
      // },
      yaxis: {
        // title: {
        //     text: 'Points',
        // },
        labels: {
          formatter: function (value) {
            return value;
          },
        },
      },
      tooltip: {
        y: [
          {
            title: {
              formatter: (val) => {
                return val;
              },
            },
          },
          {
            title: {
              formatter: (val) => {
                return val;
              },
            },
          },
          {
            title: {
              formatter: (val) => {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        borderColor: "#f1f1f1",
      },
    };
    this.grossSaleData = dashedLineChart;

    this.chartTypeArea = {
      chart: {
        height: this.totalDeliveryTipsData?.chart?.height,
        type: "area",
        zoom: {
          enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
        },
        toolbar: {
          show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
        },
      },
      stroke: {
        width: [2, 2],
        curve: "smooth",
        dashArray: [0, 0, 0],
      },
    };

    this.chartTypeBar = {
      chart: {
        height: this.totalDeliveryTipsData?.chart?.height,
        type: "bar",
        zoom: {
          enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
        },
        toolbar: {
          show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
        },
      },
    };

    this.chartTypeColumn = {
      chart: {
        height: this.totalDeliveryTipsData?.chart?.height,
        type: "bar",
        zoom: {
          enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
        },
        toolbar: {
          show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
        },
      },
      colors: ["red", "yellow"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      fill: {
        opacity: 1,
      },
    };
    this.netSaleData = dashedLineChart;
    // console.log("NETSALESGRAPHHDATAA", this.netSaleData)
    this.totalSaleData = totalOrderChart;
    this.totalTransactionData = dashedLineChart;
    this.totalRefundsData = dashedLineChart;
    // console.log("TOALREFUNDDGRAPHHDATAA", this.totalRefundsData)
    this.totalDiscountData = dashedLineChart;
    console.log("this.totalDiscountData", this.totalDiscountData);
    this.totalTaxesData = dashedLineChart;
    this.totalTipsData = dashedLineChart;
    this.totalDeliveryTipsData = dashedLineChart;
    this.getGrossSaleReport();
  }

  getChartType(type: string) {
    let chartType: Partial<ChartType> = {
      chart: {
        height: 200,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
      },
    };

    chartType = {
      chart: {
        height: this.totalDeliveryTipsData?.chart?.height,
        type: type,
        zoom: {
          enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
        },
        toolbar: {
          show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
        },
      },
    };
    console.log("chartType", chartType);
    return chartType.chart;
  }

  numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  _convertTimeKeys = {};
  convertTime(timeStamp: any) {
    if (timeStamp) {
      // if (!this._convertTimeKeys.hasOwnProperty(timeStamp)) {
        this._convertTimeKeys[timeStamp] = this.timezoneService
          .get()(timeStamp)
          .format("h:mm A");
      // }
      return this._convertTimeKeys[timeStamp];
    } else {
      return "";
    }
  }

  getLocation = (): string => {
    try {
        // Try to get the location from cookies
        let location = this.cookieService.get("storeCountry");

        // If not found in cookies, try local storage
        if (!location) {
            location = localStorage.getItem("storeCountry");
        }

        // If still not found, default to "United States"
        if (!location) {
            location = 'United States';
        }

        return location;
    } catch (error) {
        console.error('Error retrieving location:', error);
        // Fallback to "United States" in case of any error
        return 'United States';
    }
};

getState = (): string | null => {
  try {
      let state = this.cookieService.get("storeState") || localStorage.getItem("storeState");
      return state || null; // Return null if state is not found
  } catch (error) {
      console.error('Error retrieving state:', error);
      return null;
  }
};

getCity = (): string | null => {
  try {
      let city = this.cookieService.get("storeCity") || localStorage.getItem("storeCity");
      return city || null; // Return null if city is not found
  } catch (error) {
      console.error('Error retrieving city:', error);
      return null;
  }
};


  getRecommendations() {
    let country = this.getLocation()
    let state = this.getState();
    let city = this.getCity();

    // Prepare the params object
    let params = new HttpParams().set("country", country);

    // Conditionally add state and city to the params if they are defined
    if (state) {
        params = params.set("state", state);
    }
    if (city) {
        params = params.set("city", city);
    }

    this.http.get(this.GLOBALURL + "/recommendations", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"), // Ensure this gets a valid token
      }),
      params: params,
    }).subscribe(
      (response: any) => {
        if (response.success === 0) {
          this.allEventsList = [];
          // this.isEmpty = true
          // console.log("this.isEmpty", this.isEmpty)
          // this.store.dispatch(setLoadingSpinner({ status: false }));
          // Handle a failed response
          // this.toastr.error('Failed to fetch recommendations.');
        } else {
          // Process the fetched recommendations
          this.allEventsList = response.response || [];
          // this.isEmpty = false
          // console.log("this.isEmpty", this.isEmpty)
          // this.store.dispatch(setLoadingSpinner({ status: false }));
          console.log('Recommendations fetched successfully:', response.response);
          // this.toastr.success(response.message);
        }
      },
      (error) => {
        // Handle errors
        this.allEventsList = [];
        // this.isEmpty = true
            // console.log("this.isEmpty", this.isEmpty)
            // this.store.dispatch(setLoadingSpinner({ status: false }));
        // const message = this.ApiService.errorMessage(error);
        // this.toastr.error(message);
        console.error('Error fetching recommendations:', error);
      }
    );
  }

  breakdownCurrentPage = 1;
  breakdownItemsPerPage = 3;
  breakdownTotalPages = 0;
  breakdownDataLoader = false
  breakdownData = []
  // Get Breakdown Data
  async getBreakdownReport() {
    let params = {
      reportName: "breakdown_report",
      query: {
        // metric: "grossSales",
        startDate: this.breakdownStartDateDisplay,
        endDate: this.breakdownEndDateDisplay,
        // lastStartDate: this.prevStartDateDisplay,
        // lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        // interval: this.interval,
      },
    };
    this.breakdownDataLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response.success == 1) {
            console.log("breakdownData-this.currency", this.currency);
            this.breakdownDataLoader = false;
            this.breakdownData = response?.data || [];
            this.breakdownTotalPages = Math.ceil(this.breakdownData?.length / this.breakdownItemsPerPage);
            // this.totalPages = Math.ceil(this.breakdownData.length / this.itemsPerPage);
            // this.setPaginatedData();
          } else {
            //this.toastr.error(response.message)
            this.breakdownDataLoader = false;
          }
        },
        (error) => {
          this.breakdownDataLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  // paginatedData: any[] = [];
  // setPaginatedData() {
  //   const startIndex = (this.breakdownCurrentPage - 1) * this.breakdownItemsPerPage;
  //   this.paginatedData = this.breakdownData.slice(startIndex, startIndex + this.breakdownItemsPerPage);
  // }

  get paginatedData() {
    const startIndex = (this.breakdownCurrentPage - 1) * this.breakdownItemsPerPage;
    return this.breakdownData.slice(startIndex, startIndex + this.breakdownItemsPerPage);
  }
  previousPage() {
    if (this.breakdownCurrentPage > 1) {
      this.breakdownCurrentPage--;
    }
  }
  // previousPage() {
  //   if (this.breakdownCurrentPage > 1) {
  //     this.breakdownCurrentPage--;
  //     this.setPaginatedData();
  //   }
  // }
  nextPage() {
    if (this.breakdownCurrentPage < this.breakdownTotalPages) {
      this.breakdownCurrentPage++;
    }
  }
  // nextPage() {
  //   if (this.breakdownCurrentPage < this.breakdownTotalPages) {
  //     this.breakdownCurrentPage++;
  //     this.setPaginatedData();
  //   }
  // }
  goToPage(page: number) {
    if (page >= 1 && page <= this.breakdownTotalPages) {
      this.breakdownCurrentPage = page;
    }
  }
  get pageNumbers(): number[] {
    const pageNumbers = [];
    const totalPageCount = Math.min(this.breakdownTotalPages, 3);
    let startPage = Math.max(1, this.breakdownCurrentPage - 2);
    let endPage = Math.min(this.breakdownTotalPages, startPage + 2);

    if (endPage - startPage < 3) {
      startPage = Math.max(1, endPage - 3);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }

  get totalPagesArray() {
    return new Array(this.breakdownTotalPages);
  }

  async getGrossSaleReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "grossSales",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.grossSaleLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            // console.log("GROSSSALESRESS", response)
            // console.log("GROSSSALESRESSPARAMSSS", params)

            this.grossSaleDataTotal.value1 = response.total;
            this.grossSaleDataTotal.value2 = response.lastTotal;
            this.grossSaleDataTotal.percentage = response.percentage;
            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;
            // console.log("DashBoardReport Response", response)
            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.grossSale);
                //}
                pIntervalCounter++;
              });
            }

            // console.log("DashBoardReport Response", response)
            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.grossSale);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {
              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });
            // response.lastIntervals.forEach(element => {
            //   prevData.push(element.grossSale)
            // });
            // let graphCurrency: string = this.currency;
            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,
                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    if (value > 999 && value < 1000000) {
                      return graphCurrency + ' ' + (value / 1000).toFixed(0) + "K"; // convert to K for valueber from > 1000 < 1 million
                    } else if (value > 1000000) {
                      return graphCurrency + ' ' + (value / 1000000).toFixed(0) + "M"; // convert to M for valueber from > 1 million
                    } else if (value < 900) {
                      return graphCurrency + ' ' + value; // if value < 1000, nothing to do
                    }
                    // return "$ " + parseInt(value);
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };

            this.chartTypeArea = {
              chart: {
                height: this.totalDeliveryTipsData?.chart?.height,
                type: "area",
                zoom: {
                  enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
                },
                toolbar: {
                  show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
                },
              },
              stroke: {
                width: [2, 2],
                curve: "smooth",
                dashArray: [0, 0, 0],
              },
            };

            this.chartTypeBar = {
              chart: {
                height: this.totalDeliveryTipsData?.chart?.height,
                type: "bar",
                zoom: {
                  enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
                },
                toolbar: {
                  show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
                },
              },
            };

            this.chartTypeColumn = {
              chart: {
                height: this.totalDeliveryTipsData?.chart?.height,
                type: "bar",
                zoom: {
                  enabled: this.totalDeliveryTipsData?.chart?.zoom?.enabled,
                },
                toolbar: {
                  show: this.totalDeliveryTipsData?.chart?.toolbar?.show,
                },
              },
              colors: ["red", "yellow"],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "55%",
                  endingShape: "rounded",
                },
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"],
              },
              fill: {
                opacity: 1,
              },
            };
            this.grossSaleData = dashedLineChart;
            this.getNetSaleReport();
          } else {
            //this.toastr.error(response.message)
            this.grossSaleLoader = false;
          }
        },
        (error) => {
          this.grossSaleLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getNetSaleReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "netSales",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.grossSaleLoader = false;
    this.netSaleLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            // console.log("NETTSALESRESSSS", response)
            // console.log("NETSALESSSPARAMSSS", params)

            this.netSaleDataTotal.value1 = response.total;
            this.netSaleDataTotal.value2 = response.lastTotal;
            this.netSaleDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;
            // console.log("Dashboard Line 112..", response)
            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.netSales);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.netSales);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {
              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });
            // response.lastIntervals.forEach(element => {
            //   prevData.push(element.netSales)
            // });
            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    if (value > 999 && value < 1000000) {
                      return graphCurrency + ' ' + (value / 1000).toFixed(0) + "K"; // convert to K for valueber from > 1000 < 1 million
                    } else if (value > 1000000) {
                      return graphCurrency + ' ' + (value / 1000000).toFixed(0) + "M"; // convert to M for valueber from > 1 million
                    } else if (value < 900) {
                      return graphCurrency + ' ' + value; // if value < 1000, nothing to do
                    }
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.netSaleData = dashedLineChart;
            // console.log("NETTSALEGRAPHHDATAAAA", this.netSaleData)
            this.netSaleLoader = false;
            this.getTotalSalesReport();
          } else {
            // this.toastr.error(response.message)
            this.netSaleLoader = false;
          }
        },
        (error) => {
          this.netSaleLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getTotalSalesReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalOrders",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalSaleLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            // console.log("TOTALORDERSSSSS", response)
            // console.log("TOTALORDERSSPARAMSSS", params)
            this.totalSaleDataTotal.value1 = response.total;
            this.totalSaleDataTotal.value2 = response.lastTotal;
            this.totalSaleDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalOrders);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalOrders);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalSaleData = dashedLineChart;
            this.totalSaleLoader = false;
            this.getTransactionReport();
          } else {
            // this.toastr.error(response.message)
            this.totalSaleLoader = false;
          }
        },
        (error) => {
          this.totalSaleLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getTransactionReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalTransaction",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalTransactionLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            // console.log("TOTALLLTRANSACTIONSSS", response)
            // console.log("TOTALLLTRANSACTIONSPARAMSSS", params)

            this.totalTransactionDataTotal.value1 = response.total;
            this.totalTransactionDataTotal.value2 = response.lastTotal;
            this.totalTransactionDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalTransaction);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalTransaction);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalTransactionData = dashedLineChart;
            this.totalTransactionLoader = false;
            this.getrefundsReport();
          } else {
            // this.toastr.error(response.message)
            this.totalTransactionLoader = false;
          }
        },
        (error) => {
          this.totalTransactionLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getrefundsReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalRefunds",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalRefundsLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            // console.log("TOTALREFUNDDRESSS", response)
            // console.log("TOTALREFUNDDPARAMSSS", params)

            this.totalRefundsDataTotal.value1 = response.total;
            this.totalRefundsDataTotal.value2 = response.lastTotal;
            this.totalRefundsDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalRefund);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalRefund);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    if (value > 999 && value < 1000000) {
                      return graphCurrency + ' ' + (value / 1000).toFixed(0) + "K"; // convert to K for valueber from > 1000 < 1 million
                    } else if (value > 1000000) {
                      return graphCurrency + ' ' + (value / 1000000).toFixed(0) + "M"; // convert to M for valueber from > 1 million
                    } else if (value < 900) {
                      return graphCurrency + ' ' + value; // if value < 1000, nothing to do
                    }
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalRefundsData = dashedLineChart;
            console.log("TOALREFUNDDGRAPHHDATAA22", this.totalRefundsData);
            this.totalRefundsLoader = false;
            this.getdiscountReport();
          } else {
            //this.toastr.error(response.message)
            this.totalRefundsLoader = false;
          }
        },
        (error) => {
          this.totalRefundsLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getdiscountReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalDiscount",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalDiscountLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            this.totalDiscountDataTotal.value1 = response.total;
            this.totalDiscountDataTotal.value2 = response.lastTotal;
            this.totalDiscountDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalDiscount);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalDiscount);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    if (value > 999 && value < 1000000) {
                      // console.log("value > 999 && value < 1000000", value)
                      return graphCurrency + ' ' + (value / 1000).toFixed(0) + "K"; // convert to K for valueber from > 1000 < 1 million
                    } else if (value > 1000000) {
                      // console.log("value > 1000000", value)
                      return graphCurrency + ' ' + (value / 1000000).toFixed(0) + "M"; // convert to M for valueber from > 1 million
                    } else if (value < 900) {
                      // console.log("value < 900", typeof(value))
                      return graphCurrency + ' ' + value.toFixed(); // if value < 1000, nothing to do
                    }
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalDiscountData = dashedLineChart;
            // console.log("this.totalDiscountData", this.totalDiscountData);
            this.totalDiscountLoader = false;
            this.getTaxReport();
          } else {
            //this.toastr.error(response.message)
            this.totalDiscountLoader = false;
          }
        },
        (error) => {
          this.totalDiscountLoader = false;
          // this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getTaxReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalTaxes",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalTaxesLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            this.totalTaxesDataTotal.value1 = response.total;
            this.totalTaxesDataTotal.value2 = response.lastTotal;
            this.totalTaxesDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalTax);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalTax);
                // }
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    return (
                      graphCurrency + ' ' + Math.round((value + Number.EPSILON) * 100) / 100
                    );
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalTaxesData = dashedLineChart;
            this.totalTaxesLoader = false;
            this.getTipsReport();
          } else {
            //this.toastr.error(response.message)
            this.totalTaxesLoader = false;
          }
        },
        (error) => {
          this.totalTaxesLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getTipsReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalTips",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalTipsLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            this.totalTipsDataTotal.value1 = response.total;
            this.totalTipsDataTotal.value2 = response.lastTotal;
            this.totalTipsDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                //if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalTip);
                //}
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalTip);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";

              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    if (value > 999 && value < 1000000) {
                      return graphCurrency + ' ' + (value / 1000).toFixed(0) + "K"; // convert to K for valueber from > 1000 < 1 million
                    } else if (value > 1000000) {
                      return graphCurrency + ' ' + (value / 1000000).toFixed(0) + "M"; // convert to M for valueber from > 1 million
                    } else if (value < 900) {
                      return graphCurrency + ' ' + value.toFixed(); // if value < 1000, nothing to do
                    }
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalTipsData = dashedLineChart;
            this.totalTipsLoader = false;
            this.getDeliveryTipsReport();
          } else {
            //this.toastr.error(response.message)
            this.totalTipsLoader = false;
          }
        },
        (error) => {
          this.totalTipsLoader = false;
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  async getDeliveryTipsReport() {
    let params = {
      reportName: "home_report",
      query: {
        metric: "totalDeliveryFee",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        interval: this.interval,
      },
    };
    this.totalDeliveryTipsLoader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          if (response) {
            this.totalDeliveryTipsDataTotal.value1 = response.total;
            this.totalDeliveryTipsDataTotal.value2 = response.lastTotal;
            this.totalDeliveryTipsDataTotal.percentage = response.percentage;

            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1;
            let pIntervalCounter = 1;

            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }
                // if (this.interval == 'hour' || this.interval == 'year' || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.totalDelivery);
                // }
                pIntervalCounter++;
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key_as_string;
                if (this.interval == "hour") {
                  date = this.timezoneService
                    .get()(element.key)
                    .format("hh:mm A");
                } else if (this.interval == "day") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                } else if (this.interval == "month") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM");
                } else if (this.interval == "year") {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("YYYY");
                } else {
                  date = this.timezoneService
                    .get()(element.key_as_string)
                    .format("MMM DD");
                }

                //if (this.interval == 'hour' || this.interval == 'year' || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.totalDelivery);
                //}
                cIntervalCounter++;
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = "";
              if (this.interval == "hour") stringDate = currentDates[i];
              else
                stringDate =
                  currentDates[i] + " - " + (lastDates[i] ? lastDates[i] : "");
              dates.push(stringDate);
            }

            let $dates = dates.map(date => this.translatePipe.transform(date));
            forkJoin($dates).subscribe(res => {

              dates = res;
            },
            (error) => {
              console.error("Error in translating", error);
            });

            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }
            const dashedLineChart: ChartType = {
              chart: {
                height: 200,
                type: "line",
                zoom: {
                  enabled: true,
                },
                toolbar: {
                  show: false,
                },
              },
              colors: ["#000000", "#cccccc"],
              dataLabels: {
                enabled: false,
              },
              stroke: {
                width: [2, 2],
                curve: "straight",
                dashArray: [0, 0, 0],
              },
              series: [
                {
                  name: this.textCurrent,
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  data: prevData,
                },
              ],
              title: {
                text: "Page Statistics",
                align: "left",
              },
              markers: {
                size: 0,

                hover: {
                  sizeOffset: 6,
                },
              },
              xaxis: {
                type: "date",
                categories: dates,
                labels: {
                  show: false,
                },
              },

              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    if (value > 999 && value < 1000000) {
                      return graphCurrency + ' ' + (value / 1000).toFixed(0) + "K"; // convert to K for valueber from > 1000 < 1 million
                    } else if (value > 1000000) {
                      return graphCurrency + ' ' + (value / 1000000).toFixed(0) + "M"; // convert to M for valueber from > 1 million
                    } else if (value < 900) {
                      return graphCurrency + ' ' + value; // if value < 1000, nothing to do
                    }
                  },
                },
              },
              tooltip: {
                y: [
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                  {
                    title: {
                      formatter: (val) => {
                        return val;
                      },
                    },
                  },
                ],
              },
              grid: {
                borderColor: "#f1f1f1",
              },
            };
            this.totalDeliveryTipsData = dashedLineChart;
            this.totalDeliveryTipsLoader = false;
            //this.getTotalSalesReport()
          } else {
            //this.toastr.error(response.message)
            this.totalDeliveryTipsLoader = false;
          }
        },
        (error) => {
          this.totalDeliveryTipsLoader = false;
          this.toastr.success(error.message, { autoClose: false });
          //this.toastr.success(error.message);
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  checkNegative(num: any) {
    if (Math.sign(num) === -1) {
      return true;
    }

    return false;
  }

  checkZeroInc(num: any) {
    if (Math.abs(num) === 0) {
      return true;
    }
    return false;
  }
  showPlusData(num) {
    return "+" + num;
  }
  //   onItemSelect(item: any) {
  //     console.log("sssss",item);
  //     //item['item_text'] = this.truncate(item['item_text'])
  //     this.selectedItems = this.selectedItems.map((item)=>{ item['item_text'] = this.truncate(item['item_text']); return item; })
  //   }
  //   truncate(input) {
  //     if (input.length > 10) {
  //        return input.substring(0, 10) + '...';
  //     }
  //     return input;
  //  };
  handleSettings() {
    this.settings = !this.settings;
  }

  showAllLinks: boolean;
  showLinks() {
    this.showAllLinks = !this.showAllLinks
  }

  currentSlide = 0;
  slideInterval: any;

  startSlideInterval() {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 3000);
  }

  stopSlideInterval() {
    clearInterval(this.slideInterval);
  }

  referral(){
    this.router.navigate(['/refer-earn']);
  }

  nextSlide() {
    if (this.currentSlide < this.allEventsList.length - 1) {
      this.currentSlide++;
    } else {
      this.currentSlide = 0; // Loop back to the beginning
    }
  }

  previousSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    } else {
      this.currentSlide = this.allEventsList.length - 1; // Loop to the end
    }
  }

  resetSlideInterval() {
    this.stopSlideInterval();
    this.startSlideInterval();
  }

  compaignManage(item?: any) {
    console.log("Event", item)
    this.router.navigate(['loyalty/campaign-manage/event']);
    this.resetSlideInterval();
  }

  onlineStore() {
    this.router.navigate(['onlinestore']);
  }

  ngOnDestroy() {
    // Clear the interval when component is destroyed
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

}
